<template>
  <div>
    <el-dialog
      :title="title"
      align="center"
      :visible.sync="dialogVisible"
      width="40%"
      v-dialogDrag 
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <!-- <div :data="myData" class="my_data">
        <span>视频状态:{{ this.myData.status | videoStatus }}</span>
        <span>视频高度:{{ this.myData.height }}</span>
        <span>视频宽度:{{ this.myData.width }}</span>
        <span>视频时长:{{ this.myData.playTime + "s" }}</span>
      </div> -->
      <div class="media-box" id="media-box" v-if="videoShow"></div>
      <div class="media-box" id="img-box" v-if="imgShow">
        <img :src="mediaUrl" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
import { getHlsTechOptions, toHlsSource } from "@/utils/hlsPlayer";

export default {
  data() {
    return {
      dialogVisible: false,
      imgShow: true,
      mediaUrl: "",
      videoShow: false,
      title: "封面图查看",
      params: {},
      urll: "",
      myData: []
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  mounted() { },
  methods: {
    // 视频审查列表
    videoFeviewList() {
      let urll = this.urll;
      API.videoFeviewList(this.params, urll).then(res => {
        this.myData = res.data;
      });
    },
    handleClose() {
      if (this.player) {
        this.player.dispose();
      }
      this.dialogVisible = false;
      this.imgShow = false;
      this.videoShow = false;
      this.mediaUrl = "";
    },
    open(url, type, data) {
      this.dialogVisible = true;
      if (type === "img") {
        this.imgShow = true;
        this.videoShow = false;
        this.title = "封面图查看";
        this.mediaUrl = url;
      } else {
        this.imgShow = false;
        this.videoShow = true;
        this.title = "视频查看";
        this.mediaUrl =
          baseConfig.baseServerUrl +
          baseConfig.playVideoUrl +
          url +
          "?token=" +
          this.token;
        // eslint-disable-next-line no-console
        this.urll = data.id;
        this.$nextTick(function () {
          document.getElementById("media-box").innerHTML =
            `<video id="my-video"  class="video-js vjs-default-skin" controls preload="auto" style="width:100%;height:100%">
            </video>`;
          this.player = videojs(
            "my-video",
            {
              bigPlayButton: true,
              textTrackDisplay: false,
              posterImage: true,
              errorDisplay: true,
              controlBar: true,
              playbackRates: [0.5, 1, 2, 3, 4],
              ...getHlsTechOptions()
            },
            function () {
              this.play();
            }
          );
          this.player.src(toHlsSource(this.mediaUrl));
          // this.videoFeviewList();
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.my_data {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.media-box {
  width: 100%;
  height: 400px;
  text-align: center;
  overflow: hidden;
  img {
    height: 100%;
    max-width: 100%;
  }
  #my-video {
    width: 100% !important;
    height: 100% !important;
    border: none !important;
  }
}
</style>